import { AspectRatioService } from './../../../services/aspect-ratio.service';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
	selector: 'bb-player-aspect-ratio',
	templateUrl: './bb-player-aspect-ratio.html',
	styleUrls: ['./bb-player-aspect-ratio.scss'],
	// Needed to find NgForm because component is nested and as a child has no ngForm + name
	viewProviders: [ {provide: ControlContainer, useExisting: NgForm }]
})

export class BbPlayerAspectRatioComponent {
	@Input() form: NgForm;

	@Input() width: string;
	@Input() height: string;
	@Input() aspectRatio: string;
	@Input() responsiveSizing: string;
	@Input() defaultOption: string;


	@Output() widthChange: EventEmitter<string> = new EventEmitter<string>();
	@Output() heightChange: EventEmitter<string> = new EventEmitter<string>();
	@Output() aspectRatioChange: EventEmitter<string> = new EventEmitter<string>();
	@Output() responsiveSizingChange: EventEmitter<string> = new EventEmitter<string>();

	// note: this is to help the user convert width to height. Does not affect playout.aspectRatio
	lockAspectRatioFixedSize = false;
	aspectRatioFixedSize: number = null;

	constructor(
		public aspectRatioService: AspectRatioService
	) {}

	emitChange(field: string, event: string) {
		switch (field) {
			case 'width':
				this.widthChange.emit(event);
				break;
			case 'height':
				this.heightChange.emit(event);
				break;
			case 'aspectRatio':
				this.aspectRatioChange.emit(event);
				break;
			case 'responsiveSizing':
				this.responsiveSizingChange.emit(event);
				break;
		}
	}

	dimensionChanged(prop: string) {
		const counterProp = prop === 'width' ? 'height' : 'width';

		if (this[prop] && this[prop].indexOf('%') !== -1 && this.responsiveSizing === 'false') {
			this.aspectRatioFixedSize = null;
			this.lockAspectRatioFixedSize = false;
			return;
		}

		if (!this.lockAspectRatioFixedSize || !this.aspectRatioFixedSize || this[prop] === '') {
			return;
		}

		if (prop === 'width') {
			// set height
			this[counterProp] = Math.round(parseFloat(this[prop]) / this.aspectRatioFixedSize).toString();
			this.heightChange.emit(this[counterProp]);
		} else {
			// set width
			this[counterProp] = Math.round(parseFloat(this[prop]) / (1 / this.aspectRatioFixedSize)).toString();
			this.widthChange.emit(this[counterProp]);
		}
	}

	setAspectRatioFixedSize() {
		if (this.lockAspectRatioFixedSize) {
			if (this.width && this.height) {
				this.aspectRatioFixedSize = parseFloat(this.width) / parseFloat(this.height);
			} else if (this.width === '' || this.height === '') {
				// set default aspect ratio
				this.aspectRatioFixedSize = 16 / 9;
				if (this.width) {
					this.dimensionChanged('width');
				} else if (this.height) {
					this.dimensionChanged('height');
				}
			}
		} else {
			this.aspectRatioFixedSize = null;
		}
	}
}
